import { InOutMarkers } from "../store";

export const LOAD_MARKERS = "LOAD_MARKER_DATA";
export const SET_IN_MARKER_SONG_TIME = "SET_IN_MARKER_SONG_TIME";
export const SET_OUT_MARKER_SONG_TIME = "SET_OUT_MARKER_SONG_TIME";

export interface LoadMarkersAction {
  type: typeof LOAD_MARKERS;
  markers: InOutMarkers;
}

export interface SetInMarkerSongTimeAction {
  type: typeof SET_IN_MARKER_SONG_TIME;
  songTime: number;
}

export interface SetOutMarkerSongTimeAction {
  type: typeof SET_OUT_MARKER_SONG_TIME;
  songTime: number;
}

export type MarkerActionTypes =
  | LoadMarkersAction
  | SetInMarkerSongTimeAction
  | SetOutMarkerSongTimeAction;